module.exports = require("wix-window-frontend");